module.exports = __webpack_public_path__ + "img/product-update-log.c2f52514.svg";